<template>
    <input
        :id="checkboxId"
        :checked
        class="custom-control-input"
        :disabled="!isAdmin"
        :name="checkboxId"
        type="checkbox"
        @change="onCheckboxChange"
    />
    <label
        class="custom-control-label disable-text-select"
        :for="checkboxId"
    >
        <slot name="label"></slot>
    </label>
</template>

<script setup lang="ts">
const props = defineProps<{
    checkboxId: string;
    checked: HTMLInputElement['checked'];
    isAdmin: boolean;
}>();

const emit = defineEmits<{
    (e: 'checked', value: boolean): void;
}>();

function onCheckboxChange(event: Event) {
    if (props.isAdmin) {
        emit('checked', (event.target as HTMLInputElement).checked);
    }
}
</script>
